import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Title } from '../common';
import cardTypes from '~/helpers/cardTypes';
import { MaskField } from '~/elements';
import getErrorMsg from '~/helpers/errorMessages';
import { ReCaptcha } from '~/components';
import dashboardColors from '~/helpers/dashboardColors';
import getCompanyFirstNameByIssuer from '~/helpers/getCompanyFirstNameByIssuer';

const Description = styled.p`
  font-size: 0.9375rem;
  margin-bottom: 35px;
  max-width: 463px;
  line-height: 36px;
  text-align: center;
`;
const Label = styled.span`
  font-size: 0.75rem;
  margin-bottom: 10px;

  color: ${({ theme, activeCardCode }) =>
    dashboardColors(theme, activeCardCode).colorModal};
`;
const CardNumberContainer = styled.div`
  .MuiInput-underline:before {
    border-color: ${({ theme, activeCardCode }) =>
      dashboardColors(theme, activeCardCode).colorModal} !important;
  }
  .MuiInputBase-input {
    color: ${({ theme, activeCardCode }) =>
      dashboardColors(theme, activeCardCode).colorModal} !important;
  }
`;
const CardNumber = styled(MaskField)`
  max-width: 210px;
  margin-bottom: 15px !important;
`;

export default function ValidateCard({
  codigoProduto,
  formControl,
  errors,
  successReCaptcha,
  reCaptchaKey,
  issuer,
}) {
  const companyFirstName = getCompanyFirstNameByIssuer(issuer);

  return (
    <>
      <Title marginBottom="24px">
        Desbloquear {`${companyFirstName} ${cardTypes[codigoProduto]}`}
      </Title>
      <Description>
        Estamos quase lá, antes de começar, precisamos desbloquear seu{' '}
        {`${companyFirstName} ${cardTypes[codigoProduto]}`}.
      </Description>
      <Label activeCardCode={codigoProduto}>
        Informe os 16 dígitos do seu cartão
      </Label>
      <CardNumberContainer activeCardCode={codigoProduto}>
        <CardNumber
          fullWidth
          name="cardNumber"
          mask="9999  9999  9999  9999"
          type="tel"
          rules={{
            required: true,
            minLength: 22, // 22 e não 16 pois precisa contar os espaços da mask
          }}
          formControl={formControl}
          error={!!errors.cardNumber}
          caption={getErrorMsg(errors, 'cardNumber')}
        />
      </CardNumberContainer>
      {reCaptchaKey && (
        <ReCaptcha
          onChange={successKey => successReCaptcha(successKey)}
          sitekey={reCaptchaKey}
        />
      )}
    </>
  );
}

ValidateCard.propTypes = {
  codigoProduto: PropTypes.string,
  errors: PropTypes.object,
  formControl: PropTypes.object.isRequired,
  successReCaptcha: PropTypes.func.isRequired,
  reCaptchaKey: PropTypes.string,
  issuer: PropTypes.string,
};
